// لینک بنر/اسلایدی که فقط یک تصویر یا ویدیو دارد، نام قابل‌خواندن برای screen reader ندارد مگر alt تصویر.
// alt از پنل می‌آید و تصویر موبایل اغلب بدون alt ذخیره می‌شود، و ویدیو اصلاً alt ندارد. پس وقتی alt خالی است
// (یا اسلاید ویدیو است) لینک یک نام ثابت می‌گیرد تا بی‌نام نماند.
// عنوان‌های `title` کارت و رسانه عمداً استفاده نمی‌شوند: نام داخلی ردیف در پنل است («بنر اول ۳تایی - موبایل») و
// برای کاربر معنی ندارد. نام درست را باید تیم محتوا در alt بنر بنویسد؛ این فقط جلوی لینک بی‌نام را می‌گیرد.
// وقتی alt پر باشد چیزی برنمی‌گردد تا نام لینک (همان alt) دوبار خوانده نشود.
const VIDEO_SLIDE_TYPE = 2;

const first_text = (...values) => values.find((value) => typeof value === "string" && value.trim())?.trim();

export const slide_link_props = (card, fallback = "بنر تبلیغاتی") => {
    const alt = first_text(card?.media?.alt);
    if (alt && card?.slide_type !== VIDEO_SLIDE_TYPE) return {};

    return { "aria-label": alt || fallback };
};
